/**
 * 시나리오 단위 시작/타임아웃 액션.
 * 논서술형 챕터는 여러 시나리오로 나뉘어 있고 시나리오마다 별도 제한시간이 있어,
 * 이 두 액션으로 서버 쪽 타이머 상태를 맞춘다.
 */
import api from "pages/api/axiosInstance";
import {
  ScenarioStartResponse,
  ScenarioTimeoutResponse,
  SuspendBlockAnswer,
} from "./types";

interface BaseResponse<T> {
  isSuccess: boolean;
  code: number;
  message: string;
  result: T;
}

/** 시나리오 시작. `POST /app/essay-learning/scenarios/{id}/start` */
export const postEssayScenarioStart = async (
  scenarioId: number
): Promise<ScenarioStartResponse> => {
  const res = await api.post<BaseResponse<ScenarioStartResponse>>(
    `/app/essay-learning/scenarios/${scenarioId}/start`
  );
  return res.data.result;
};

/**
 * 미션 제출(0:00 자동·"미션 마무리" 수동 공통).
 * `POST /app/essay-learning/scenarios/{id}/timeout`
 *
 * nextScenarioId로 다음 시나리오 자동 진입. chapterCompleted=true면 챕터 자동 submit.
 *
 * @param finalBlocks 이 미션 문항들의 화면 최종 답안 칸. 서버가 잠그기 직전 이 값으로 칸을 확정한다.
 *   비어 있으면 본문 없이 보내고, 서버는 자동저장된 값 그대로 잠근다.
 *   다른 미션 문항이 섞이면 404(NOT_FOUND_ESSAY_QUESTION), valueJson 4000자 초과면 400.
 */
export const postEssayScenarioTimeout = async (
  scenarioId: number,
  finalBlocks: SuspendBlockAnswer[] = []
): Promise<ScenarioTimeoutResponse> => {
  const res = await api.post<BaseResponse<ScenarioTimeoutResponse>>(
    `/app/essay-learning/scenarios/${scenarioId}/timeout`,
    finalBlocks.length > 0 ? { blocks: finalBlocks } : undefined
  );
  return res.data.result;
};
